export const LOCAL_STORAGE_KEY = 'StorageAlias';

export const TEAM_NAMES = [
  'BabyRage',
  'BatChest',
  'cmonBruh',
  'CoolCat',
  'DansGame',
  'DatSheffy',
  'DendiFace',
  'EleGiggle',
  'FailFish',
  'FrankerZ',
  'FreakinStinkin',
  'HeyGuys',
  'HotPokket',
  'Jebaited',
  'Kappa',
  'KappaPride',
  'Kreygasm',
  'LUL',
  'MingLee',
  'OSFrog',
  'OpieOP',
  'PoroSad',
  'ResidentSleeper',
  'RlyTho',
  'SeemsGood',
  'SwiftRage',
  'TriHard',
  'WutFace',
];

export const TEAM_COLORS = ['#6D374B', '#D00000', '#6F9596', '#E0A100', '#9FA167', '#3476AD'];

export enum Keybinds {
  PlayPause = ' ',
  CorrectGuess = 'c',
  SkipWord = 's',
  AddPlayer = 'Enter',
}
